import Mention from "./mentions";

export default Mention;